import { render, staticRenderFns } from "./demo1.0.vue?vue&type=template&id=67986aea&scoped=true&"
import script from "./demo1.0.vue?vue&type=script&lang=js&"
export * from "./demo1.0.vue?vue&type=script&lang=js&"
import style0 from "./demo1.0.vue?vue&type=style&index=0&id=67986aea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67986aea",
  null
  
)

export default component.exports